import { useEffect } from "react";
import { BB_AUTH_COMPLETE_MESSAGE } from "@/lib/auth/beginGoogleSignIn";
import { consumeAuthReturnInBrowser } from "@/lib/auth/consumeAuthReturnInBrowser";
import { requireSupabase } from "@/lib/supabase";

type Props = {
  onDone?: () => void;
};

export default function AuthCallback({ onDone }: Props) {
  useEffect(() => {
    let mounted = true;

    const finishAuth = async () => {
      const sb = requireSupabase();
      await consumeAuthReturnInBrowser(sb);

      const { data } = await sb.auth.getSession();
      if (!data.session) {
        console.warn(
          "Auth callback reached but no active session was found. If you started sign-in on a Vercel preview URL " +
            "but landed on production, add this deployment's callback to Supabase Redirect URLs (see src/lib/authRedirect.ts)."
        );
      }

      if (data.session && typeof window !== "undefined" && window.opener && !window.opener.closed) {
        try {
          window.opener.postMessage({ type: BB_AUTH_COMPLETE_MESSAGE }, window.location.origin);
        } catch {
          /* COOP can block opener access; localStorage still shared */
        }
        window.close();
        return;
      }

      if (mounted) onDone?.();
    };

    void finishAuth();

    return () => {
      mounted = false;
    };
  }, [onDone]);

  return <div>Signing you in...</div>;
}

